import firebase from "./firebase";

export const sampleContacts = [
  // 5 Customers
  {
    firstName: "Sarah",
    lastName: "Mitchell",
    email: "sarah.mitchell@email.com",
    phoneNumber: "(555) 234-5678",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "123 Oak Street",
    deliveryCity: "Portland",
    deliveryRegion: "OR",
    deliveryZipCode: "97201",
    deliveryCountry: "United States",
    contactType: "customer",
    contactCompany: "",
    contactOccupation: "Architect",
    contactAssociation: "",
    contactShow: "",
    description: "Purchased 20ft yurt in 2023",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 5),
    contactLand: "Yes",
    contactContractor: "Self",
    contactFinancing: "Cash",
    priorCustomer: ""
  },
  {
    firstName: "James",
    lastName: "Rodriguez",
    email: "j.rodriguez@email.com",
    phoneNumber: "(555) 876-5432",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "456 Pine Avenue",
    deliveryCity: "Boulder",
    deliveryRegion: "CO",
    deliveryZipCode: "80301",
    deliveryCountry: "United States",
    contactType: "customer",
    contactCompany: "",
    contactOccupation: "Teacher",
    contactAssociation: "",
    contactShow: "",
    description: "Purchased 16ft yurt in 2022",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 12),
    contactLand: "Yes",
    contactContractor: "Hired",
    contactFinancing: "Loan",
    priorCustomer: ""
  },
  {
    firstName: "Emily",
    lastName: "Chen",
    email: "emily.chen@email.com",
    phoneNumber: "(555) 345-6789",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "789 Mountain Road",
    deliveryCity: "Asheville",
    deliveryRegion: "NC",
    deliveryZipCode: "28801",
    deliveryCountry: "United States",
    contactType: "customer",
    contactCompany: "",
    contactOccupation: "Writer",
    contactAssociation: "",
    contactShow: "",
    description: "Purchased 24ft yurt in 2023",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 2),
    contactLand: "Yes",
    contactContractor: "Self",
    contactFinancing: "Cash",
    priorCustomer: ""
  },
  {
    firstName: "Michael",
    lastName: "Thompson",
    email: "m.thompson@email.com",
    phoneNumber: "(555) 456-7890",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "321 Desert View",
    deliveryCity: "Santa Fe",
    deliveryRegion: "NM",
    deliveryZipCode: "87501",
    deliveryCountry: "United States",
    contactType: "customer",
    contactCompany: "",
    contactOccupation: "Engineer",
    contactAssociation: "",
    contactShow: "",
    description: "Purchased 27ft yurt in 2021",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 8),
    contactLand: "Yes",
    contactContractor: "Hired",
    contactFinancing: "Cash",
    priorCustomer: ""
  },
  {
    firstName: "Amanda",
    lastName: "Williams",
    email: "amanda.w@email.com",
    phoneNumber: "(555) 567-8901",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "654 River Lane",
    deliveryCity: "Bend",
    deliveryRegion: "OR",
    deliveryZipCode: "97701",
    deliveryCountry: "United States",
    contactType: "customer",
    contactCompany: "",
    contactOccupation: "Designer",
    contactAssociation: "",
    contactShow: "",
    description: "Purchased 32ft yurt in 2023",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 15),
    contactLand: "Yes",
    contactContractor: "Self",
    contactFinancing: "Loan",
    priorCustomer: ""
  },

  // 15 Mixed Contact Types (inquiries, vendors, designers, etc.)
  {
    firstName: "David",
    lastName: "Park",
    email: "david.park@email.com",
    phoneNumber: "(555) 678-9012",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "",
    deliveryCity: "Missoula",
    deliveryRegion: "MT",
    deliveryZipCode: "59801",
    deliveryCountry: "United States",
    contactType: "inquiry",
    contactCompany: "",
    contactOccupation: "",
    contactAssociation: "",
    contactShow: "",
    description: "Interested in 20ft yurt",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 1),
    contactLand: "Looking",
    contactContractor: "",
    contactFinancing: "",
    priorCustomer: ""
  },
  {
    firstName: "Jessica",
    lastName: "Martinez",
    email: "jessica.m@email.com",
    phoneNumber: "(555) 789-0123",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "",
    deliveryCity: "Taos",
    deliveryRegion: "NM",
    deliveryZipCode: "87571",
    deliveryCountry: "United States",
    contactType: "vendor",
    contactCompany: "Mountain Lumber Supply",
    contactOccupation: "Supplier",
    contactAssociation: "",
    contactShow: "",
    description: "Timber supplier",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 3),
    contactLand: "",
    contactContractor: "",
    contactFinancing: "",
    priorCustomer: ""
  },
  {
    firstName: "Robert",
    lastName: "Anderson",
    email: "r.anderson@email.com",
    phoneNumber: "(555) 890-1234",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "",
    deliveryCity: "Flagstaff",
    deliveryRegion: "AZ",
    deliveryZipCode: "86001",
    deliveryCountry: "United States",
    contactType: "inquiry",
    contactCompany: "",
    contactOccupation: "Retired",
    contactAssociation: "",
    contactShow: "",
    description: "Interested in 16ft yurt for property",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 7),
    contactLand: "Yes",
    contactContractor: "",
    contactFinancing: "",
    priorCustomer: ""
  },
  {
    firstName: "Lisa",
    lastName: "Johnson",
    email: "lisa.johnson@email.com",
    phoneNumber: "(555) 901-2345",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "",
    deliveryCity: "Bozeman",
    deliveryRegion: "MT",
    deliveryZipCode: "59715",
    deliveryCountry: "United States",
    contactType: "designer",
    contactCompany: "Montana Design Co",
    contactOccupation: "Interior Designer",
    contactAssociation: "ASID",
    contactShow: "",
    description: "Designs custom yurt interiors",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 10),
    contactLand: "",
    contactContractor: "",
    contactFinancing: "",
    priorCustomer: ""
  },
  {
    firstName: "Christopher",
    lastName: "Brown",
    email: "chris.brown@email.com",
    phoneNumber: "(555) 012-3456",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "",
    deliveryCity: "Durango",
    deliveryRegion: "CO",
    deliveryZipCode: "81301",
    deliveryCountry: "United States",
    contactType: "inquiry",
    contactCompany: "",
    contactOccupation: "Photographer",
    contactAssociation: "",
    contactShow: "",
    description: "Interested in 24ft yurt studio",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 4),
    contactLand: "Looking",
    contactContractor: "",
    contactFinancing: "",
    priorCustomer: ""
  },
  {
    firstName: "Rachel",
    lastName: "Davis",
    email: "rachel.davis@email.com",
    phoneNumber: "(555) 123-4567",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "",
    deliveryCity: "Eugene",
    deliveryRegion: "OR",
    deliveryZipCode: "97401",
    deliveryCountry: "United States",
    contactType: "vendor",
    contactCompany: "Pacific Canvas & Textiles",
    contactOccupation: "Supplier",
    contactAssociation: "",
    contactShow: "",
    description: "Canvas and fabric supplier",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 14),
    contactLand: "",
    contactContractor: "",
    contactFinancing: "",
    priorCustomer: ""
  },
  {
    firstName: "Kevin",
    lastName: "Taylor",
    email: "kevin.taylor@email.com",
    phoneNumber: "(555) 234-5679",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "",
    deliveryCity: "Telluride",
    deliveryRegion: "CO",
    deliveryZipCode: "81435",
    deliveryCountry: "United States",
    contactType: "inquiry",
    contactCompany: "",
    contactOccupation: "Software Developer",
    contactAssociation: "",
    contactShow: "",
    description: "Remote work yurt inquiry",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 6),
    contactLand: "Yes",
    contactContractor: "",
    contactFinancing: "",
    priorCustomer: ""
  },
  {
    firstName: "Nicole",
    lastName: "Garcia",
    email: "nicole.garcia@email.com",
    phoneNumber: "(555) 345-6790",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "",
    deliveryCity: "Sedona",
    deliveryRegion: "AZ",
    deliveryZipCode: "86336",
    deliveryCountry: "United States",
    contactType: "designer",
    contactCompany: "Desert Spaces LLC",
    contactOccupation: "Architect",
    contactAssociation: "AIA",
    contactShow: "",
    description: "Specializes in alternative structures",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 18),
    contactLand: "",
    contactContractor: "",
    contactFinancing: "",
    priorCustomer: ""
  },
  {
    firstName: "Brian",
    lastName: "Wilson",
    email: "brian.wilson@email.com",
    phoneNumber: "(555) 456-7891",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "",
    deliveryCity: "Whitefish",
    deliveryRegion: "MT",
    deliveryZipCode: "59937",
    deliveryCountry: "United States",
    contactType: "inquiry",
    contactCompany: "",
    contactOccupation: "Contractor",
    contactAssociation: "",
    contactShow: "",
    description: "Interested in yurts for client projects",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 9),
    contactLand: "Client owned",
    contactContractor: "",
    contactFinancing: "",
    priorCustomer: ""
  },
  {
    firstName: "Angela",
    lastName: "Moore",
    email: "angela.moore@email.com",
    phoneNumber: "(555) 567-8902",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "",
    deliveryCity: "Bellingham",
    deliveryRegion: "WA",
    deliveryZipCode: "98225",
    deliveryCountry: "United States",
    contactType: "vendor",
    contactCompany: "Northwest Hardware Co",
    contactOccupation: "Supplier",
    contactAssociation: "",
    contactShow: "",
    description: "Hardware and fastener supplier",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 11),
    contactLand: "",
    contactContractor: "",
    contactFinancing: "",
    priorCustomer: ""
  },
  {
    firstName: "Steven",
    lastName: "Lee",
    email: "steven.lee@email.com",
    phoneNumber: "(555) 678-9013",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "",
    deliveryCity: "Jackson",
    deliveryRegion: "WY",
    deliveryZipCode: "83001",
    deliveryCountry: "United States",
    contactType: "inquiry",
    contactCompany: "",
    contactOccupation: "Ski Instructor",
    contactAssociation: "",
    contactShow: "",
    description: "Looking for 20ft yurt",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 2),
    contactLand: "Looking",
    contactContractor: "",
    contactFinancing: "",
    priorCustomer: ""
  },
  {
    firstName: "Michelle",
    lastName: "White",
    email: "michelle.white@email.com",
    phoneNumber: "(555) 789-0124",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "",
    deliveryCity: "Moab",
    deliveryRegion: "UT",
    deliveryZipCode: "84532",
    deliveryCountry: "United States",
    contactType: "designer",
    contactCompany: "Red Rock Design Studio",
    contactOccupation: "Landscape Architect",
    contactAssociation: "ASLA",
    contactShow: "",
    description: "Incorporates yurts into property designs",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 16),
    contactLand: "",
    contactContractor: "",
    contactFinancing: "",
    priorCustomer: ""
  },
  {
    firstName: "Daniel",
    lastName: "Harris",
    email: "daniel.harris@email.com",
    phoneNumber: "(555) 890-1235",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "",
    deliveryCity: "Crested Butte",
    deliveryRegion: "CO",
    deliveryZipCode: "81224",
    deliveryCountry: "United States",
    contactType: "inquiry",
    contactCompany: "",
    contactOccupation: "Artist",
    contactAssociation: "",
    contactShow: "",
    description: "Interested in 16ft art studio yurt",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 5),
    contactLand: "Yes",
    contactContractor: "",
    contactFinancing: "",
    priorCustomer: ""
  },
  {
    firstName: "Karen",
    lastName: "Clark",
    email: "karen.clark@email.com",
    phoneNumber: "(555) 901-2346",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "",
    deliveryCity: "Sisters",
    deliveryRegion: "OR",
    deliveryZipCode: "97759",
    deliveryCountry: "United States",
    contactType: "inquiry",
    contactCompany: "",
    contactOccupation: "Yoga Instructor",
    contactAssociation: "",
    contactShow: "",
    description: "Interested in 27ft studio space",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 13),
    contactLand: "Looking",
    contactContractor: "",
    contactFinancing: "",
    priorCustomer: ""
  },
  {
    firstName: "Thomas",
    lastName: "Lewis",
    email: "thomas.lewis@email.com",
    phoneNumber: "(555) 012-3457",
    mailingStreetAddress: "",
    mailingCity: "",
    mailingRegion: "",
    mailingZipCode: "",
    mailingCountry: "",
    deliveryStreetAddress: "",
    deliveryCity: "Park City",
    deliveryRegion: "UT",
    deliveryZipCode: "84060",
    deliveryCountry: "United States",
    contactType: "vendor",
    contactCompany: "Mountain Windows & Doors",
    contactOccupation: "Supplier",
    contactAssociation: "",
    contactShow: "",
    description: "Skylights and window supplier",
    createdTime: Date.now() - (1000 * 60 * 60 * 24 * 20),
    contactLand: "",
    contactContractor: "",
    contactFinancing: "",
    priorCustomer: ""
  }
];

const pixels = 6;

const createWall = (id, kitName, heightInInches) => ({
  pixels: pixels,
  twoByW: 1.5 * pixels,
  twoByH: 3.5 * pixels,
  w: 48 * pixels,
  h: heightInInches,
  stud: 24 * pixels,
  window1: {
    windowW: 42 * pixels,
    windowH: 42 * pixels,
    sill: 24 * pixels,
    header: 5.5 * pixels,
    headerAmount: 0,
    windowType: "FIXED",
    placement: 0,
    tempered: "STANDARD",
  },
  window2: {
    windowW: 42 * pixels,
    windowH: 42 * pixels,
    sill: 24 * pixels,
    header: 5.5 * pixels,
    headerAmount: 0,
    windowType: "FIXED",
    placement: 0,
    tempered: "STANDARD",
  },
  windows: 0,
  windowW: 42 * pixels,
  windowH: 42 * pixels,
  sill: 24 * pixels,
  header: 5.5 * pixels,
  headerAmount: 0,
  windowType: 0,
  placement: 0,
  id: id,
  notes: "",
  windowEdgeTrim: false,
  cornerTrim: false,
  kitName: kitName,
  doors: 0,
  doorH: 82 * pixels,
  doorW: 38 * pixels,
  frenchDoor: null,
  frenchHeader: 9.25 * pixels,
  frenchHeaderAmount: 0,
  frenchW: "5ft",
  stackPos: id,
});

export const sampleProjects = [
  {
    kitName: "Mitchell",
    size: 16,
    h: 720, // 10 feet = 120 inches * 6 * 12
    walls: Array.from({ length: 16 }, (_, i) => createWall(i, "Mitchell", 120)),
    created: Date.now() - (1000 * 60 * 60 * 24 * 5),
    modified: Date.now() - (1000 * 60 * 60 * 24 * 2),
    bottomPlate: "FIR",
    eaves: 16,
    due: Date.now() + (1000 * 60 * 60 * 24 * 30),
    stud: 16 * pixels,
    stack: [],
    status: "in-progress",
    contactId: "local-1", // Sarah Mitchell
    color: "#3B82F6",
    designer: "Matthew Smith",
    engineer: "Eclipse Eng.",
    productionDate: new Date(Date.now() + (1000 * 60 * 60 * 24 * 10)).toISOString().split('T')[0],
    completeTime: 14,
    initialDeposit: true,
    halfPayment: true,
    fullPayment: false,
    estimatedRevenue: 18500,
    moneyReceived: 13875
  },
  {
    kitName: "Rodriguez",
    size: 20,
    h: 864,
    walls: Array.from({ length: 20 }, (_, i) => createWall(i, "Rodriguez", 144)),
    created: Date.now() - (1000 * 60 * 60 * 24 * 12),
    modified: Date.now() - (1000 * 60 * 60 * 24 * 5),
    bottomPlate: "CEDAR",
    eaves: 16,
    due: Date.now() + (1000 * 60 * 60 * 24 * 45),
    stud: 16 * pixels,
    stack: [],
    status: "planning",
    contactId: "local-2", // James Rodriguez
    color: "#10B981",
    designer: "Juliette Dubroca",
    engineer: "Eclipse Eng.",
    productionDate: new Date(Date.now() + (1000 * 60 * 60 * 24 * 25)).toISOString().split('T')[0],
    completeTime: 21,
    initialDeposit: true,
    halfPayment: false,
    fullPayment: false,
    estimatedRevenue: 15200,
    moneyReceived: 4560
  },
  {
    kitName: "Chen",
    size: 24,
    h: 720, // 14 feet = 168 inches * 6 * 12
    walls: Array.from({ length: 24 }, (_, i) => createWall(i, "Chen", 168)),
    created: Date.now() - (1000 * 60 * 60 * 24 * 2),
    modified: Date.now() - (1000 * 60 * 60 * 24 * 1),
    bottomPlate: "FIR",
    eaves: 18,
    due: Date.now() + (1000 * 60 * 60 * 24 * 60),
    stud: 24 * pixels,
    stack: [],
    status: "design",
    contactId: "local-3", // Emily Chen
    color: "#8B5CF6",
    designer: "Mollie Hunt",
    engineer: "None",
    productionDate: new Date(Date.now() + (1000 * 60 * 60 * 24 * 40)).toISOString().split('T')[0],
    completeTime: 28,
    initialDeposit: false,
    halfPayment: false,
    fullPayment: false,
    estimatedRevenue: 24800,
    moneyReceived: 0
  },
  {
    kitName: "Thompson",
    size: 27,
    h: 720, // 12 feet = 144 inches * 6 * 12
    walls: Array.from({ length: 27 }, (_, i) => createWall(i, "Thompson", 144)),
    created: Date.now() - (1000 * 60 * 60 * 24 * 8),
    modified: Date.now() - (1000 * 60 * 60 * 24 * 3),
    bottomPlate: "FIR",
    eaves: 20,
    due: Date.now() + (1000 * 60 * 60 * 24 * 15),
    stud: 16 * pixels,
    stack: [],
    status: "fabrication",
    contactId: "local-4", // Michael Thompson
    color: "#F59E0B",
    designer: "Michael Fahie",
    engineer: "Eclipse Eng.",
    productionDate: new Date(Date.now() + (1000 * 60 * 60 * 24 * 5)).toISOString().split('T')[0],
    completeTime: 10,
    initialDeposit: true,
    halfPayment: true,
    fullPayment: true,
    estimatedRevenue: 28900,
    moneyReceived: 28900
  },
  {
    kitName: "Williams",
    size: 32,
    h: 720, // 14 feet = 168 inches * 6 * 12 (max valid height)
    walls: Array.from({ length: 32 }, (_, i) => createWall(i, "Williams", 168)),
    created: Date.now() - (1000 * 60 * 60 * 24 * 15),
    modified: Date.now() - (1000 * 60 * 60 * 24 * 7),
    bottomPlate: "CEDAR",
    eaves: 24,
    due: Date.now() + (1000 * 60 * 60 * 24 * 90),
    stud: 24 * pixels,
    stack: [],
    status: "planning",
    contactId: "local-5", // Amanda Williams
    color: "#EC4899",
    designer: "Jeff Flowers",
    engineer: "None",
    productionDate: new Date(Date.now() + (1000 * 60 * 60 * 24 * 70)).toISOString().split('T')[0],
    completeTime: 35,
    initialDeposit: true,
    halfPayment: false,
    fullPayment: false,
    estimatedRevenue: 35600,
    moneyReceived: 10680
  }
];

export const seedContacts = async () => {
  const firestore = firebase.firestore();
  const batch = firestore.batch();

  console.log("Starting to seed contacts...");

  sampleContacts.forEach((contact) => {
    const docRef = firestore.collection("contacts").doc();
    batch.set(docRef, contact);
  });

  try {
    await batch.commit();
    console.log("Successfully added 20 sample contacts!");
  } catch (error) {
    console.error("Error seeding contacts:", error);
  }
};

export const seedProjects = async () => {
  const firestore = firebase.firestore();
  const batch = firestore.batch();

  console.log("Starting to seed projects...");

  sampleProjects.forEach((project) => {
    const docRef = firestore.collection("projects").doc();
    batch.set(docRef, project);
  });

  try {
    await batch.commit();
    console.log("Successfully added 5 sample projects!");
  } catch (error) {
    console.error("Error seeding projects:", error);
  }
};
